import { render, staticRenderFns } from "./jira_integration.vue?vue&type=template&id=13f990ca&scoped=true&"
import script from "./jira_integration.vue?vue&type=script&lang=js&"
export * from "./jira_integration.vue?vue&type=script&lang=js&"
import style0 from "./jira_integration.vue?vue&type=style&index=0&id=13f990ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f990ca",
  null
  
)

export default component.exports